import QuestionPage from '@app-studio-web/ui/pages/QuestionPage'
import { useTranslation } from 'react-i18next'
import { useSubmit } from 'react-router-dom'
import useUpdateMode from '../../hooks/useUpdateMode'
import { saveAnswer } from '../../utils/onboardingStorage'

const QUESTION_KEY = 'past_attempts'

export default function PastAttemptsPage() {
  const submit = useSubmit()
  const { t } = useTranslation()

  const { isUpdate, postToReactNative } = useUpdateMode()

  const onSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    const formData = new FormData(event.currentTarget)
    const formAnswer = formData.get('answer') as string

    const answer = {
      question_key: QUESTION_KEY,
      question: 'Have you tried dream journaling before?',
      answer_key: formAnswer.toLowerCase(),
      answer: formAnswer,
    }

    if (isUpdate) {
      postToReactNative(answer)
    } else {
      saveAnswer(QUESTION_KEY, answer)
      submit(formData, { method: 'post' })
    }
  }

  return (
    <QuestionPage
      heading={t('pages.onboarding.pastAttempts.heading')}
      buttons={[
        {
          text: `📓 ${t('pages.onboarding.pastAttempts.options.regularly')}`,
          value: 'Yes, I journal regularly',
          subtext: t('pages.onboarding.pastAttempts.subtexts.regularly'),
        },
        {
          text: `📝 ${t('pages.onboarding.pastAttempts.options.triedBefore')}`,
          value: 'I tried but stopped',
          subtext: t('pages.onboarding.pastAttempts.subtexts.triedBefore'),
        },
        {
          text: `🤔 ${t('pages.onboarding.pastAttempts.options.onceOrTwice')}`,
          value: 'Once or twice',
          subtext: t('pages.onboarding.pastAttempts.subtexts.onceOrTwice'),
        },
        {
          text: `✨ ${t('pages.onboarding.pastAttempts.options.never')}`,
          value: 'Never - this is new for me',
          subtext: t('pages.onboarding.pastAttempts.subtexts.never'),
        },
      ]}
      onSubmit={onSubmit}
      headingSize="text-3xl"
      buttonTextSize="text-base"
      buttonBgColor="bg-white"
    />
  )
}
